<template>
	<div>
		<a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :disabled="uploading"
						accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
			<a-button type = "default" icon = "upload">选择文件 </a-button>
		</a-upload>
		<a-button icon="cloud-upload" type="primary" :loading="uploading" :disabled="fileList.length == 0"
						style="margin: 1.25rem 0;" @click="doSubmit">
			开始上传
		</a-button>
		<a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" :model="resultObj" labelAlign="left">
			<a-form-model-item label="用户添加数量">
				<a-input  v-model="resultObj.c_add"/>
			</a-form-model-item>
			<a-form-model-item label="已包含用户数量">
				<a-input v-model="resultObj.c_added"/>
			</a-form-model-item>
			<a-form-model-item label="表添加数量">
				<a-input  v-model="resultObj.m_add"/>
			</a-form-model-item>
			<a-form-model-item label="已包含表数量"  >
				<a-input  v-model="resultObj.m_added"/>
			</a-form-model-item>
			<a-form-model-item label="包含用户信息"  >
				<a-textarea   v-model="resultObj.c_nums" :autoSize="true"/>
			</a-form-model-item>
			<a-form-model-item label="包含表信息"  >
				<a-textarea   v-model="resultObj.m_addrs" :autoSize="true"/>
			</a-form-model-item>
		</a-form-model>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				fileList:[],
				uploading: false,
				resultObj:{},
			}
		},
		methods:{
			beforeUpload:function(file){
				let flag  = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
				if(flag){
					this.fileList = [];
					this.fileList = [...this.fileList, file];
				}else{
					this.$message.error('只能上传Excel文件');
				}
				return false;
			},
			handleRemove:function(file){
				const index = this.fileList.indexOf(file);
				const newFileList = this.fileList.slice();
				newFileList.splice(index, 1);
				this.fileList = newFileList;
			},
			doSubmit:function(){
				this.uploading = true;
				this.$emit('uploadingChange',[true]);
				const formData = new FormData();
				formData.append('file', this.fileList[0]);
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_BATCH_ADD_URL);
				this.Api.fetchPostWithFiles(url,formData).then((data)=>{
					this.uploading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						let flag = result['flag'];
						if(flag){
							this.resultObj = {
								c_add:result['c_add'],
								c_added:result['c_added'],
								m_add:result['m_add'],
								m_added:result['m_added'],
								c_nums:result['c_nums'],
								m_addrs:result['m_addrs']
							};
							this.$emit('uploadingChange',[false]);
						}else{
							let msgs = result['msg'];
							this.$message.error(msgs);
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.uploading = false;
					console.log(error);
				});
			},
		}
	}
</script>

<style>
</style>
